export default function ({ $auth, redirect, app, route }) {
  // console.debug('[isUser.js] (if) $auth.user  (then) return redirect(\'/users\')')
  if ($auth.user) {

    return redirect(app.localePath('/users'))
  }
}
